module.exports = __webpack_public_path__ + "img/images_marketing_bg1.10916ab7.png";